import {schema as Schema} from 'normalizr';

export const sessionItemBuilderEntity = new Schema.Entity('items', {}, {idAttribute: 'id'});
export const sessionBuilderItemsSchema = new Schema.Array(sessionItemBuilderEntity);
